<template>
  <div class="input-group mb-3 w-50">
    <input type="number" class="form-control text-right" placeholder="duration"
      v-model="duration"
      @change="updateDuration"
      :disabled="demoSettings.enabled || connected || isConnecting">
    <div class="input-group-append text-left">
      <span class="input-group-text">seconds</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'

export default {
  name: 'demo',
  data () {
    return {
      duration: null
    }
  },
  computed: {
    ...mapGetters(['demoSettings', 'connected', 'device']),
    isConnecting () {
      return this.device && this.device.isConnecting
    }
  },
  methods: {
    ...mapMutations(['toggleDemo', 'setDemoDuration']),
    action () {
      this.toggleDemo()
    },
    updateDuration: _.debounce(function (e) {
      this.duration = Math.max(this.demoSettings.minDuration, e.target.value)
      this.duration = Math.min(this.demoSettings.maxDuration, this.duration)
      this.setDemoDuration(this.duration)
    }, 0)
  },
  created () {
    this.duration = this.demoSettings.duration
  }
}
</script>




// WEBPACK FOOTER //
// src/components/controls/DemoDuration.vue